import useSubscriptions from "@/queries/use_subscriptions.ts";
import EmptyState from "@components/empty_state.tsx";
import Fingerprint6 from "@images/fingerprint_6.svg";
import useTranslation from "@hooks/use_translation.ts";
import { JobAlertsRow } from "@components/dashboard/widgets/job_alerts/row.tsx";

export const JobAlertsList = () => {
  const { t } = useTranslation("jobAlerts");
  const {
    data: { subscriptions },
  } = useSubscriptions();

  if (subscriptions.length === 0) {
    return <EmptyState svg={Fingerprint6} svgSize="150" message={t("noJobAlerts")} />;
  }

  const sortedSubscriptions = [...subscriptions]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 5);

  return (
    <div>
      {sortedSubscriptions.map((subscription) => (
        <JobAlertsRow key={subscription.editPath} subscription={subscription} />
      ))}
    </div>
  );
};
